const level1 = ["Admin"];
const level2 = ["Admin", "Instructor"];
const level3 = ["Admin", "Instructor", "Manager"];

export { level1, level2, level3 };
